module.exports = __webpack_public_path__ + "img/active_product3.fac7de5.webp";